import productDimensions from './product';
import sessionDimensions from './session';

export default {
  ...productDimensions,
  ...sessionDimensions,
};
